'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	AtlasUtil = require('../models/atlas-util'),
	_ = require('underscore');

module.exports = function AtlasModel(config, collaborationModel, goldAtlasApi, mapMetadataModel, optional) {
	if (!config || !collaborationModel || !goldAtlasApi || !mapMetadataModel) {
		throw 'invalid-args';
	}
	let itIsKnown;
	const self = observable(this),
		trunc = (optional && optional.trunc) || AtlasUtil.truncate,
		sanitize = (optional && optional.sanitize) || AtlasUtil.sanitize,
		titleLengthLimit = (optional && optional.titleLengthLimit) || 40,
		descriptionLengthLimit = (optional && optional.descriptionLengthLimit) || 150,
		getContext = function () {
			if (!itIsKnown || !itIsKnown.slug) {
				return Promise.resolve({});
			}
			return goldAtlasApi.exists(itIsKnown.slug)
			.then((result) => {
				return (result && {
					atlasUrl: config.atlasUrl + result + 'index.html'
				}) || {};
			});
		},
		dispatchContext = function () {
			getContext()
			.then((context) => self.dispatchEvent('atlasStatusContext', context));
		},
		onContentChanged = function (activeContent) {
			const previousAtlasExport = activeContent.getAttr('previous-atlas-export');

			if (_.isEqual(itIsKnown, previousAtlasExport)) {
				return;
			}
			itIsKnown = previousAtlasExport;
			dispatchContext();
		},
		getAtlasTitle = () => {
			const metaName = mapMetadataModel.getCurrentName(),
				activeContent = collaborationModel.getActiveContent(),
				previousExport = activeContent.getAttr('previous-atlas-export');

			if (previousExport && previousExport.title) {
				return previousExport.title;
			}
			if (metaName && metaName !== config.defaultFileTitle) {
				return metaName;
			}
			return activeContent.findSubIdeaById(activeContent.getDefaultRootId()).title || config.defaultFileTitle;
		};

	collaborationModel.addEventListener('mm-active-content-changed', onContentChanged);
	self.removePublishedMap = () => {
		const activeContent = collaborationModel.getActiveContent(),
			previousAtlasExport = activeContent.getAttr('previous-atlas-export');
		if (!previousAtlasExport || !previousAtlasExport.slug) {
			activeContent.updateAttr(activeContent.id, 'previous-atlas-export', false);
			return Promise.resolve();
		}
		return goldAtlasApi.delete(previousAtlasExport.slug)
		.then(() => activeContent.updateAttr(activeContent.id, 'previous-atlas-export', false));
	};

	self.slugExists = goldAtlasApi.exists;

	self.storePublishingResult = (exported) => {
		const activeContent = collaborationModel.getActiveContent();
		return activeContent.updateAttr(activeContent.id, 'previous-atlas-export', _.extend({publishedTimestamp: Date.now()}, exported));
	};
	self.sanitize = sanitize;
	self.getExportValues = () => {
		const activeContent = collaborationModel.getActiveContent(),
			previousExport = activeContent.getAttr('previous-atlas-export'),
			title = getAtlasTitle(),
			saneTitle = trunc(title, titleLengthLimit),
			saneDescription = (previousExport && previousExport.description) || (trunc('MindMup mind map: ' + title, descriptionLengthLimit)),
			slug = (previousExport && previousExport.slug) || (trunc(title, titleLengthLimit)),
			saneSlug = sanitize(slug);


		return {
			title: saneTitle,
			description: saneDescription,
			slug: saneSlug,
			gaClientCode: previousExport && previousExport.gaClientCode
		};
	};
};
